import React, { Fragment, useEffect, useState } from 'react';
import 'semantic-ui-css/semantic.min.css';
import '@material/react-linear-progress/dist/linear-progress.css';
import LinearProgress from '@material/react-linear-progress';
import { isEmpty } from 'lodash';
import { isBefore, parseISO, addDays } from 'date-fns';

import { GlobalStyle } from './assets/css/style';
import { Footer, Form, Heading, InfoPlan } from './components';
import api from './service/api';

const App = () => {
  const [closed, setClosed] = useState(true);

  /**
   * Close loading.
   *
   * @param close
   * @returns {Promise<void>}
   */
  const handleClose = async close => {
    await setClosed(close);
  };

  /**
   * Cria token do usuário.
   *
   * @returns {Promise<void>}
   */
  const handleToken = async () => {
    await setClosed(false);

    const time = addDays(new Date(), 1);

    try {
      const response = await api.post('/login', {
        username: 'integracao_minutrade',
        company_name: 'amigoo',
        password: 'f3LzSJ16JcnptPCg',
      });

      sessionStorage.setItem('amigooPet', JSON.stringify({
        token: response.data.sessionToken,
        expire_in: time,
      }));
    } catch (e) {
      await console.log(e);
    } finally {
      await setClosed(true);
    }
  };

  useEffect(() => {
    const amigooPet = JSON.parse(sessionStorage.getItem('amigooPet'));

    if (isEmpty(amigooPet)) {
      // noinspection JSIgnoredPromiseFromCall
      handleToken();
    } else {
      const parsedDate = parseISO(amigooPet.expire_in);

      if (isBefore(parsedDate, new Date())) {
        sessionStorage.removeItem('amigooPet');
        // noinspection JSIgnoredPromiseFromCall
        handleToken();
      }
    }
  }, []);

  return (
    <Fragment>
      <GlobalStyle/>
      <LinearProgress
        indeterminate
        closed={closed}
      />
      <Heading/>
      <InfoPlan/>
      <Form
        handleClose={value => handleClose(value)}
        createToken={() => handleToken()}
      />
      <Footer/>
    </Fragment>
  );
};

export default App;